<!-- Category selector -->
<p-tabs [(value)]="activeTab" class="surface-0" (valueChange)="onTabChange()">
  <p-tablist>
    <p-tab *ngFor="let cat of categories; index as i" [value]="i">
      <span class="font-semibold">{{ cat.label }}</span>
    </p-tab>
  </p-tablist>

  <!-- ── Tabs content ── -->
  <p-tabpanels>
    <p-tabpanel *ngFor="let cat of categories; index as i" [value]="i">
      <!-- Filter bar -->
      <div class="flex align-items-center gap-3 mb-3">
        <input pInputText [(ngModel)]="searchText" placeholder="Search demos…" class="w-22rem" />

        <p-multiSelect
          [options]="tagPalette"
          [(ngModel)]="activeTagsArray"
          placeholder="Filter by tag(s)"
          class="w-18rem"
          display="chip"
        ></p-multiSelect>

        <button
          pButton
          icon="pi pi-times"
          tooltip="Clear filters"
          class="p-button-text p-button-sm ml-auto"
          (click)="clearFilters()"
        ></button>
      </div>

      <!-- Cards -->
      <ng-container *ngIf="activeTab === i">
        <p-virtualscroller class="demo-scroller" [items]="visibleLoans" [itemSize]="60" scrollHeight="450px">
          <ng-template #item let-loan let-opt="options">
            <div class="demo-card" (click)="select(loan)" [ngClass]="{ odd: opt.odd }">
              <div class="flex align-items-center justify-content-between">
                <div class="flex align-items-center gap-3 flex-grow-1">
                  <div>
                    <h4 class="m-0 flex align-items-center gap-2">
                      {{ loan.title }}
                      <i
                        *ngIf="loan.notes"
                        class="pi pi-info-circle text-600"
                        pTooltip="{{ loan.notes }}"
                        tooltipPosition="top"
                      ></i>
                    </h4>
                    <span class="subtitle">{{ loan.subtitle }}</span>
                  </div>
                </div>

                <div class="flex gap-1 ml-3">
                  <p-tag
                    *ngFor="let t of loan.tags"
                    [value]="t"
                    severity="contrast"
                    class="font-medium px-3 py-1 rounded-lg"
                  />
                </div>
              </div>
            </div>
          </ng-template>
        </p-virtualscroller>
      </ng-container>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
